export const MATERIAL_START = 'material/material-start';
export const MATERIAL_SUCCESS = 'material/material-success';
export const MATERIAL_ERROR = 'material/material-error';
